<p-card styleClass="border-none shadow-none mb-1 p-0 custom-card-scope">
  <ng-template pTemplate="body">
    <div class="flex align-items-center justify-content-between p-0 m-0">
      <button
        pButton
        icon="pi pi-arrow-left"
        class="p-button-text p-button-rounded"
        aria-label="Back"
        (click)="backToMyUsersScreen()"
      ></button>

      <div class="flex items-center gap-4 flex-1 ml-2">
        <span
          class="rounded-full flex items-center justify-center text-xs font-semibold mr-3"
          [ngStyle]="
            getAssigneeStyles(
              userDetails()?.firstName + ' ' + userDetails()?.lastName
            )
          "
        >
          {{
            getUserInitials(userDetails()?.firstName, userDetails()?.lastName)
          }}
        </span>
        <h5 class="text-md font-semibold m-0 flex-auto">
          {{ userDetails()?.firstName }} {{ userDetails()?.lastName }}
        </h5>
      </div>
    </div>
  </ng-template>
</p-card>

<p-card class="m-1 shadow-sm" *ngIf="userEditForm">
  <form [formGroup]="userEditForm" class="grid grid-cols-4 gap-4 items-end">
    <p-floatlabel variant="on" class="col-span-1">
      <input
        id="firstName"
        pInputText
        formControlName="firstName"
        class="w-full"
      />
      <label for="firstName">First Name</label>
    </p-floatlabel>

    <p-floatlabel variant="on" class="col-span-1">
      <input
        id="lastName"
        pInputText
        formControlName="lastName"
        class="w-full"
      />
      <label for="lastName">Last Name</label>
    </p-floatlabel>

    <p-floatlabel variant="on" class="col-span-1">
      <input id="emailId" pInputText formControlName="emailId" class="w-full" />
      <label for="emailId">Email</label>
    </p-floatlabel>

    <p-floatlabel variant="on" class="col-span-1">
      <input
        id="timeZone"
        pInputText
        formControlName="timeZone"
        class="w-full"
      />
      <label for="timeZone">Time Zone</label>
    </p-floatlabel>

    <p-floatlabel variant="on" class="col-span-1">
      <input
        id="employeeCode"
        pInputText
        formControlName="employeeCode"
        class="w-full"
        maxlength="50"
        (keypress)="allowEmployeeCode($event)"
      />
      <label for="employeeCode">Employee Code</label>
    </p-floatlabel>

    <p-floatlabel variant="on" class="col-span-1">
      <p-inputNumber
        inputId="dayCountForBackDatedEntry"
        formControlName="dayCountForBackDatedEntry"
        [min]="0"
        [max]="backDateEntry.days"
        [step]="1"
        [mode]="'decimal'"
        [useGrouping]="false"
        class="w-full"
      ></p-inputNumber>
      <label for="dayCountForBackDatedEntry">Day Count (Backdated Entry)</label>
    </p-floatlabel>

    <p-floatlabel variant="on" class="col-span-1">
      <input
        id="reportingManager"
        pInputText
        formControlName="reportingManager"
        class="w-full"
      />
      <label for="reportingManager">Reporting Manager</label>
    </p-floatlabel>

    <p-floatlabel variant="on" class="col-span-1">
      <input
        id="secondaryReportingManagerName"
        pInputText
        formControlName="secondaryReportingManagerName"
        class="w-full"
      />
      <label for="secondaryReportingManagerName"
        >Secondary Reporting Manager</label
      >
    </p-floatlabel>

    <p-floatlabel variant="on" class="col-span-1">
      <input
        id="departmentId"
        pInputText
        formControlName="departmentId"
        class="w-full"
      />
      <label for="departmentId">Department</label>
    </p-floatlabel>

    <p-floatlabel variant="on" class="col-span-1">
      <input
        id="locationName"
        pInputText
        formControlName="locationName"
        class="w-full"
      />
      <label for="locationName">Location</label>
    </p-floatlabel>

    <p-floatlabel variant="on" class="col-span-1">
      <input id="roleId" pInputText formControlName="roleId" class="w-full" />
      <label for="roleId">Access Role</label>
    </p-floatlabel>

    <p-floatlabel variant="on" class="col-span-1">
      <input
        id="timeCaptureScheme"
        pInputText
        formControlName="timeCaptureScheme"
        class="w-full"
      />
      <label for="timeCaptureScheme">Time Capture Scheme</label>
    </p-floatlabel>

    <p-floatlabel variant="on" class="col-span-1">
      <input
        pInputText
        twTimeInput
        inputId="minHours"
        [style]="{ width: '100%' }"
        formControlName="minHours"
        maxlength="8"
        [format]="'HH:mm'"
      />
      <label for="minHours" class="required-label"
        >Minimum Time Entries (hh:mm)</label
      >
    </p-floatlabel>

    <p-floatlabel variant="on" class="col-span-1">
      <input
        id="userShift"
        pInputText
        formControlName="userShiftId"
        class="w-full"
      />
      <label for="userShift">User Shift</label>
    </p-floatlabel>

    <div class="col-span-1 flex items-center p-2 justify-between">
      <div class="flex items-center gap-4">
        <div class="flex items-center gap-2">
          <p-checkbox
            formControlName="isActive"
            inputId="isActive"
            binary="true"
          ></p-checkbox>
          <label for="isActive">Active</label>
        </div>
        <div class="flex items-center gap-2">
          <p-checkbox
            formControlName="isReportingManager"
            inputId="isReportingManager"
            binary="true"
          ></p-checkbox>
          <label for="isReportingManager">Reporting Manager</label>
        </div>
      </div>
    </div>
  </form>
</p-card>

<p-card class="m-4" *ngIf="userDetails()?.isReportingManager">
  <h3 class="text-md font-semibold m-1 whitespace-nowrap">
    Backup Reporting Manager
  </h3>
  <div class="flex items-center gap-6 w-full">
    <form
      *ngIf="secondaryReportingManageruserEditForm"
      [formGroup]="secondaryReportingManageruserEditForm"
      class="flex items-center gap-4 w-full"
    >
      <p-floatlabel variant="on" class="w-[250px]">
        <p-select
          [options]="users"
          formControlName="secondaryReportingManagerId"
          optionLabel="fullName"
          optionValue="id"
          placeholder="Select Reporting Manager"
          [filter]="true"
          filterBy="fullName"
          [showClear]="true"
          class="w-full"
          [panelStyle]="{ width: '250px' }"
        ></p-select>
      </p-floatlabel>

      <p-button
        *ngIf="CanUpdateSecondaryManager"
        label="Update"
        icon="pi pi-check"
        (click)="updateUser()"
      ></p-button>
    </form>
  </div>
</p-card>
<p-card class="m-4">
  <p-table
    [value]="filteredProjects"
    stripedRows
    [paginator]="true"
    [rows]="50"
    size="small"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    [rowsPerPageOptions]="[50, 100, 150]"
    [scrollable]="true"
    scrollHeight="39vh"
  >
    <ng-template #header>
      <tr>
        <th>Project Name</th>
        <th>Access Role in Project</th>
        <th>Total Utilization</th>
      </tr>
    </ng-template>
    <ng-template #body let-customer>
      <tr>
        <td>{{ customer.projectName || '-' }}</td>
        <td>{{ customer.roleName || '-' }}</td>
        <td>{{ customer.utilizationPercentage || '-' }}</td>
      </tr>
    </ng-template>
    <ng-template #emptymessage>
      <tr>
        <td colspan="3">No Project found.</td>
      </tr>
    </ng-template>
  </p-table>
</p-card>

@if (usersUnderManager.length > 0) {
  <p-card class="m-4" *ngIf="userDetails()?.isReportingManager">
    <div class="flex items-center gap-6 w-full">
      <h3 class="text-md font-semibold m-0 whitespace-nowrap">
        Reporting Users
      </h3>
    </div>
  </p-card>
  <p-card class="mt-12" *ngIf="userDetails()?.isReportingManager">
    <p-table
      [value]="usersUnderManager"
      stripedRows
      [paginator]="true"
      [rows]="50"
      size="small"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      [rowsPerPageOptions]="[50, 100, 150]"
      [scrollable]="true"
      scrollHeight="39vh"
    >
      <ng-template #header>
        <tr>
          <th>User Name</th>
          <th>Email Id</th>
          <th>Access Role</th>
          <th>Department</th>
          <th>Location</th>
          <th>Time Zone</th>
          <th>Time Capture Scheme</th>
        </tr>
      </ng-template>
      <ng-template #body let-user>
        <tr>
          <td>
            {{ (user.firstName || '') + ' ' + (user.lastName || '') || '-' }}
          </td>
          <td>{{ user.emailId || '-' }}</td>
          <td>{{ user.roleName || '-' }}</td>
          <td>{{ user.departmentName || '-' }}</td>
          <td>{{ user.locationName || '-' }}</td>
          <td>{{ user.timeZone || '-' }}</td>
          <td>{{ user.timeCaptureScheme || '-' }}</td>
        </tr>
      </ng-template>
      <ng-template #emptymessage>
        <tr>
          <td colspan="7">No Reporting Users found.</td>
        </tr>
      </ng-template>
    </p-table>
  </p-card>
}
